// extracted by mini-css-extract-plugin
export default {"formItemsWithNoMargin":"style_formItemsWithNoMargin__Uj2SU","noWrapFlex":"style_noWrapFlex__QJr5D"};